import { render } from "./NewsEdit.vue?vue&type=template&id=fb159bdc&scoped=true"
import script from "./NewsEdit.vue?vue&type=script&lang=js"
export * from "./NewsEdit.vue?vue&type=script&lang=js"

import "./NewsEdit.vue?vue&type=style&index=0&id=fb159bdc&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb159bdc"]])

export default __exports__